import React from 'react';
import { useAchievementsContext } from '../../../../contexts/AchievementsContext/AchievementsContext';
import { useMemoryBankContext } from '../../../../contexts/MemoryBankContext/MemoryBankContext';
import { AddBranch } from './AddBranch';

export function AddBranchContextWrapper(props) {
  const achievements = useAchievementsContext();
  const { memories } = useMemoryBankContext();
  const { branch } = props;
  // `branch` prop is the full episode list (legacy name; see StoryBranches state).
  const branches = Array.isArray(branch) ? branch : [];
  const globalContext = {
    achievements,
    memories,
    branches,
  };

  return (
    <AddBranch
      {...props}
      globalContext={globalContext}
    />
  );
}
